import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import Logo from '../../../components/Logo';

const PageNotFound = () => {
    const { t } = useTranslation();

    return (
        <Box sx={{ textAlign: 'center' }}>
            <Logo size="80px" />
            <Typography variant="h4" sx={{ mt: 3, mb: 1 }}>{t('pageNotFound.title')}</Typography>
            <Typography sx={{ mb: 3, color: (theme) => theme.custom.muted }}>{t('pageNotFound.description')}</Typography>
            <Link to="/">{t('pageNotFound.goHome')}</Link>
        </Box>
    );
};

export default PageNotFound;
